import UniversalImage from "library/UniversalImage"
import { fmobile, fresponsive } from "library/fullyResponsive"
import styled, { css } from "styled-components"
import colors from "styles/colors"
import textStyles from "styles/text"
import type { HomeFeatureCard } from "types/aliases"

export default function Card({ card }: { card: HomeFeatureCard }) {
	return (
		<Wrapper>
			<Image
				key={card?.title}
				image={card?.image?.childImageSharp?.gatsbyImageData}
				alt={""}
			/>
			<Row>
				<Title>{card?.title}</Title>
				{card?.hasTag && <Tag>Coming Soon</Tag>}
			</Row>
			<Description
				$width={card?.descriptionWidth ?? ""}
				$mobileWidth={card?.mobileDescriptionWidth ?? "100%"}
			>
				{card?.description}
			</Description>
		</Wrapper>
	)
}

const Wrapper = styled.div`
	${fresponsive(css`
		width: 430px;
		height: auto;
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		border-radius: 15px;
		border: 1px solid ${colors.grey1};
		background: ${colors.pureWhite};
		gap: 24px;
		padding: 20px 20px 26px;
		opacity: 0;
	`)}

	${fmobile(css`
		width: 322.5px;
		padding: 15px 15px 19.5px;
		gap: 18px;
		transform: unset;
		opacity: 1;
		scale: 1;
	`)}
`

const Image = styled(UniversalImage)`
	${fresponsive(css`
		width: 390px;
		height: 250px;
	`)}

	${fmobile(css`
		width: 100%;
		height: auto;
	`)}
`

const Title = styled.div`
	${fresponsive(css`
		${textStyles.sub1};
		color: ${colors.charcoal};
		margin: -4px 0 -6px;
	`)}

	${fmobile(css`
		${textStyles.sub2};
		margin: -4px 0 -5px;
	`)}
`

const Description = styled.div<{ $width: string; $mobileWidth: string }>`
	${({ $width }) =>
		fresponsive(css`
			${textStyles.p2};
			color: ${colors.grey2};
			margin: -5px 0;
			width: ${$width};
		`)}

	${({ $mobileWidth }) =>
		fmobile(css`
			${textStyles.p3};
			width: ${$mobileWidth};
			text-align: left;
		`)}
`

const Row = styled.div`
	${fresponsive(css`
		display: flex;
		gap: 12px;
		align-items: center;
		height: 13px;
		overflow: visible;
	`)}
`

const Tag = styled.div`
	border: 0.5px solid ${colors.transBlue1};

	${fresponsive(css`
		color: ${colors.blue3};
		${textStyles.kicker3};
		border-radius: 8px;
		background: ${colors.transBlue2};
		width: 80px;
		height: 22.5px;
		display: flex;
		align-items: center;
		justify-content: center;
	`)}

	${fmobile(css`
		width: 60px;
		height: 17px;
		font-size: 7.5px;
		border-radius: 6px;
	`)}
`
